import httpRequest from '../../common/lib/http-request';

// *******************
// ASSOCIATE SERVICES
// *******************

function checkProfessionalName(associateId, professionalName) {
    return httpRequest({
        url: '/Associate/professional/check',
        method: 'POST',
        data: {
            associateId: associateId,
            professionalName: professionalName
        }
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function checkAssociateExists(request) {
    return httpRequest({
        url: '/Associate/check/',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

const AssociateService = { checkProfessionalName, checkAssociateExists }

export default AssociateService;